module.exports = __webpack_public_path__ + "img/3.8dfc5a3d.png";